import { FormikProps, withFormik } from "formik";
import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa6";
import { object, string } from "yup";
import { Input } from "../shared/Input";

export interface IChangePasswordProps {
  onSubmit: (values: any, actions: any) => void;
  toggleForm: () => void;
}

interface FormikValues {
  oldPassword: string;
  newPassword: string;
}

function ChangePassword(
  props: FormikProps<FormikValues> & IChangePasswordProps
) {
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);

  return (
    <form
      onSubmit={props.handleSubmit}
      className="flex justify-center bg-white"
    >
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
        <div className="text-center mb-6">
          <div className="mb-4 text-justify">
            <h2 className="text-2xl font-semibold text-gray-800 text-center pb-7">
              Change Password
            </h2>
            <p className="text-sm text-gray-600">
              Enter your new password below. Make sure it's something secure.
            </p>
          </div>

          <div className="grid gap-4">
            <div className="relative">
              <Input
                label="Old Password"
                name="oldPassword"
                values={props.values}
                errors={props.errors}
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                touches={props.touched}
                placeholder="Enter your Old Password"
                className="block w-full px-2 mt-2 py-2 border text-xs border-[#b0afb3] rounded-md focus:border-[#b0afb3] focus:outline-none"
                type={showOldPassword ? "text" : "password"}
              />
              <span
                className="absolute right-3 top-[42px] transform cursor-pointer text-gray-500"
                onClick={() => setShowOldPassword(!showOldPassword)}
              >
                {showOldPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            {/* New Password Input */}
            <div className="relative h-fit">
              <Input
                label="New Password"
                name="newPassword"
                values={props.values}
                errors={props.errors}
                onChange={props.handleChange}
                onBlur={props.handleBlur}
                touches={props.touched}
                placeholder="Enter your New Password"
                className="block w-full px-2 mt-2 py-2 border text-xs border-[#b0afb3] rounded-md focus:border-[#b0afb3] focus:outline-none"
                type={showNewPassword ? "text" : "password"}
              />
              <span
                className="absolute right-3 top-[42px] transform cursor-pointer text-gray-500"
                onClick={() => setShowNewPassword(!showNewPassword)}
              >
                {showNewPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            {/* Submit and Cancel Buttons */}
            <div className="flex py-3 flex-col items-center justify-center lg:flex-row lg:justify-center lg:items-center gap-3">
              <button
                type="submit"
                className="w-full cursor-pointer lg:w-40 h-12 text-white font-semibold content-center text-center bg-[#05A30D] hover:opacity-70  rounded-lg lg:rounded-none lg:rounded-tl-2xl lg:rounded-br-2xl"
              >
                {props.isSubmitting ? "Submitting ..." : "Submit"}
              </button>
              <button
                onClick={props.toggleForm}
                type="button"
                className="w-full cursor-pointer lg:w-40 h-12 text-black font-semibold content-center hover:opacity-70  text-center bg-[#C9CCC9] rounded-lg lg:rounded-none lg:rounded-tl-2xl lg:rounded-br-2xl"
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
}

// export default withFormik<IChangePasswordProps, FormikValues>({
//   validationSchema: object().shape({
//     oldPassword: string().required("Old Password is required"),
//     newPassword: string().required("New Password is required"),
//   }),
//   mapPropsToValues: () => ({
//     oldPassword: "",
//     newPassword: "",
//   }),
//   handleSubmit: (values, { props, setSubmitting }) => {
//     props.onSubmit(values, { setSubmitting });
//   },
// })(ChangePassword);
export default withFormik<IChangePasswordProps, FormikValues>({
  validationSchema: object().shape({
    oldPassword: string().required("Old Password is required"),
    newPassword: string()
      .required("New Password is required")
      .min(8, "New Password must be at least 8 characters")
      .matches(/[A-Z]/, "New Password must contain at least one uppercase letter")
      .matches(/[a-z]/, "New Password must contain at least one lowercase letter")
      .matches(/[0-9]/, "New Password must contain at least one digit")
      .matches(
        /[!@#$%^&*(),.?":{}|<>]/,
        "New Password must contain at least one special character"
      ),
  }),
  mapPropsToValues: () => ({
    oldPassword: "",
    newPassword: "",
  }),
  handleSubmit: (values, { props, setSubmitting }) => {
    props.onSubmit(values, { setSubmitting });
  },
})(ChangePassword);
